mainApp.directive('eventViewer', function() {
    return {
        templateUrl: '/public/directives/eventViewer.html',
        scope: {
            data: "=?",
            field: "@?",
            filters: "=?",
            facets: "=?",
            datamodified: "=?",
            waitforfilter: "@?"
        },
        link: function($scope, elem, attrs) {
            $scope.el = elem;
        },
        controller: ['$scope', '$location', '$interval', '$rootScope', function($scope, element) {


        }]
    };
});